import debounce from "lodash/debounce";
import { useState } from "react";
import { FaSearch } from "react-icons/fa";

const SearchInput = ({
  placeholder,
  onSearch,
}: {
  placeholder: string;
  onSearch: (value: string) => void;
}) => {
  const [value, setValue] = useState<string>("");

  const handleSearch = (searchValue: string) => {
    onSearch(searchValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch(value);
    }
  };

  return (
    <div className="flex items-center border border-gray-300 rounded-lg p-2 gap-2">
      <input
        value={value}
        onChange={(e) => {
          const v = e.target.value;
          setValue(v);
          debounce(handleSearch, 500)(v);
        }}
        type="text"
        placeholder={placeholder}
        className="flex-1 outline-none text-sm text-gray-700 placeholder-gray-400 text-center w-full"
        onKeyDown={handleKeyDown}
      />
      <button onClick={() => handleSearch(value)}>
        <FaSearch className="text-gray-400 mr-2 hover:text-[#C64192] hover:cursor-pointer" />
      </button>
    </div>
  );
};

export default SearchInput;
